import { useState, useEffect, useRef } from 'react';
import { useGetSurvey } from '../client-api/survey';

export const useSurveyBadge = (userId, loggedin, hideBadge) => {
  const [shouldShowBadge, setShouldShowBadge] = useState(false);
  const timeoutRef = useRef(null);
  
  // Only fetch survey if user is logged in and has an ID
  const { data: surveyData, isLoading, error } = useGetSurvey(userId);
  
  useEffect(() => {
    // Clear any existing timeout
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
    
    // Don't show badge if:
    // 1. User is not logged in
    // 2. User data is not loaded yet
    // 3. Survey data exists (user has completed car info)
    // 4. Badge should be hidden for current route
    // 5. Still loading survey data
    const canShow = loggedin && 
                   userId && 
                   !isLoading && 
                   !surveyData && 
                   !hideBadge;
    
    // Add a small delay to prevent flashing during state changes
    timeoutRef.current = setTimeout(() => {
      setShouldShowBadge(canShow);
    }, 100);
    
    // Cleanup timeout on unmount
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, [loggedin, userId, isLoading, surveyData, hideBadge]);

  return {
    shouldShowBadge,
    isLoading,
    surveyData
  };
};
